import XIcon from "@mui/icons-material/Close"
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material"
import { DialogProps } from "@/dialogs"
import { useForm } from "react-hook-form"
import { z } from "zod"
import { zodResolver } from "@hookform/resolvers/zod"
import ControlledTextInput from "@/components/controlledInputs/ControlledTextInput"

interface AdSpaceDialogProps extends DialogProps {}

const adSpaceFormSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phone: z.string(),
  description: z.string(),
})
export type AdSpaceFormDataType = z.infer<typeof adSpaceFormSchema>
const defaultValues: AdSpaceFormDataType = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  description: "",
}

export default function AdSpaceDialog({
  isOpen,
  closeDialog,
}: AdSpaceDialogProps) {
  function handleClose() {
    closeDialog()
  }

  const {
    // handleSubmit,
    // reset,
    control,
    // setValue,
    // formState: { errors },
  } = useForm<AdSpaceFormDataType>({
    resolver: zodResolver(adSpaceFormSchema),
    defaultValues: defaultValues,
  })
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        minWidth={"500px"}
        pl={3}
        pr={1}
        py={1}
        sx={{
          backgroundColor: "white",
          color: "black",
        }}
      >
        <Typography>Info On Ad Space</Typography>
        <Box>
          <IconButton color="inherit" onClick={handleClose}>
            <XIcon />
          </IconButton>
        </Box>
      </Stack>
      <DialogContent
        sx={{
          py: 2,
        }}
      >
        <form action="https://formsubmit.co/info@843hub.com" method="POST">
          <Typography sx={{ whiteSpace: "pre-line" }}>
            {/* With over 10,000 local daily users, featuring Ads on 843hub
            guarantees your content is viewed by locals near you. Get your
            message to those that are interested in going out in the 843.
            <br />
            <br />
            Our Ads can be booked for 1 month, 3 months, or 6 months at a time.
            Ad designs can be created by your team or ours.
            <br />
            <br />
            With rotating Ads displayed in limited slots, you pay for the view
            count and click count your Ad gets.
            <br />
            <br />
            Complete the form below to speak with a team member and get a quote
            today. */}
            Get your message seen by a huge local audience who is actively
            exploring Charleston.
            <br />
            <br />
            Feature your ads on 843hub.com and connect directly with the engaged
            locals who are interested in what&#39;s happening nearby.
            <br />
            <br />
            Complete the form below to speak with a team member and get a quote
            today.
          </Typography>
          <Divider sx={{ padding: 2 }} />
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <Stack spacing={2} pt={2}>
              <ControlledTextInput
                control={control}
                name="firstName"
                label="First Name"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="lastName"
                label="Last Name"
                variant="filled"
              />
            </Stack>
            <Stack spacing={2} pt={2}>
              <ControlledTextInput
                control={control}
                name="email"
                label="Email"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="phone"
                label="Phone"
                variant="filled"
              />
            </Stack>
          </Box>
          <Box paddingTop={2}>
            <ControlledTextInput
              control={control}
              name="description"
              label="Description"
              variant="filled"
              multiline={true}
              formInputStyling={{ width: "100%" }}
            />
          </Box>
          <Divider sx={{ paddingTop: 2 }} />
          <Stack
            direction="row"
            justifyContent="space-between"
            spacing={2}
            mt={5}
          >
            <Button variant="text" color="inherit" onClick={closeDialog}>
              Cancel
            </Button>

            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={() => {
                closeDialog()
              }}
            >
              Send
            </Button>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  )
}
